import script from "./Vibe.vue?vue&type=script&setup=true&lang=js"
export * from "./Vibe.vue?vue&type=script&setup=true&lang=js"

import "./Vibe.vue?vue&type=style&index=0&id=fad84ff8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad84ff8"]])

export default __exports__